import React, {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import PrivateRequest from '../../api/PrivateRequest'

import toast, {Toaster} from 'react-hot-toast'
import { VerifyCode } from './VerifyCode'
import request from '../../api/request'

const initialValues = {
  national_code: '',
  mobileNumber: '',
}

const forgotPasswordSchema = Yup.object().shape({
  national_code: Yup.number().required('فیلد کد ملی اجباری است '),
  mobileNumber: Yup.number().required('فیلد شماره موبایل الزامی است '),
})

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [UserData, setUserData] = useState<any>(null)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(false)
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      request.post('/forgetpassword', {
        national_code: values.national_code,
        mobile_number: values.mobileNumber,
      })
        .then((res: any) => {
          console.log('res foget', res)
          toast.success('کد بازیابی رمز عبور برای شما پیامک شد')
          setLoading(false)
          setUserData(res.data.user)
          setHasErrors(false)
        })
        .catch((err) => {
          toast.error(err.response.data.err)
          setLoading(false)
          console.log('err pass', err)
        })
    },
  })

  return (
    <>
      <Toaster />
      {!hasErrors && UserData === null ? (
        <form
          className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
          noValidate
          id='kt_login_password_reset_form'
          onSubmit={formik.handleSubmit}
        >
          <div className='text-center mb-10'>
            {/* begin::Title */}
            <h1 className='text-dark mb-3'> فراموشی رمز عبور </h1>
            {/* end::Title */}

            {/* begin::Link */}
            <div className='text-gray-400 fw-bold fs-4'>
              برای بازیابی رمز عبور کد ملی و شماره موبایل خود را وارد کنید
            </div>
            {/* end::Link */}
          </div>

          {/* begin::Title */}

          {/* {hasErrors === false && (
           <div className='mb-10 bg-light-info p-8 rounded'>
             <div className='text-info'>کد تغییر رمز عبور برای شماره شما پیامک شد</div>
           </div>
         )} */}
          {/* end::Title */}

          {/* begin::Form group */}
          <div className='fv-row mb-10'>
            <label className='form-label fw-bolder text-gray-900 fs-6 flex justify-end'>
              کد ملی
            </label>
            <input
              type='text'
              style={{direction: 'rtl'}}
              dir={'rtl'}
              placeholder='کد ملی خود را وارد کنید '
              autoComplete='off'
              {...formik.getFieldProps('national_code')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {'is-invalid': formik.touched.national_code && formik.errors.national_code},
                {
                  'is-valid': formik.touched.national_code && !formik.errors.national_code,
                }
              )}
            />
            {formik.touched.national_code && formik.errors.national_code && (
              <div className='fv-plugins-message-container flex justify-content-end mt-2'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.national_code}</span>
                </div>
              </div>
            )}
          </div>

          <div className='fv-row mb-10'>
            <label className='form-label fw-bolder text-gray-900 fs-6 flex justify-end'>
              شماره موبایل{' '}
            </label>
            <input
              type='text'
              style={{direction: 'rtl'}}
              dir={'rtl'}
              placeholder='شماره موبایل خود را وارد کنید'
              autoComplete='off'
              {...formik.getFieldProps('mobileNumber')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {'is-invalid': formik.touched.mobileNumber && formik.errors.mobileNumber},
                {
                  'is-valid': formik.touched.mobileNumber && !formik.errors.mobileNumber,
                }
              )}
            />
            {formik.touched.mobileNumber && formik.errors.mobileNumber && (
              <div className='fv-plugins-message-container flex justify-content-end mt-2'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.mobileNumber}</span>
                </div>
              </div>
            )}
          </div>
          {/* end::Form group */}

          {/* begin::Form group */}
          <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
            <button
              type='submit'
              id='kt_password_reset_submit'
              className='btn btn-lg bg-teal rounded-pill btn-primary fw-bolder me-4 m-2'
            >
              {loading === false && (
                <span className='indicator-label'>ارسال کد بازیابی رمز عبور </span>
              )}
              {loading === true && (
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              )}
            </button>
            <Link to='/auth/login'>
              <button
                type='button'
                id='kt_login_password_reset_form_cancel_button'
                className='btn rounded-pill bg-gray-200 btn-lg btn-light-primary fw-bolder m-2'
                disabled={formik.isSubmitting || !formik.isValid}
              >
                انصراف
              </button>
            </Link>{' '}
          </div>
          {/* end::Form group */}
        </form>
      ) : (
        <VerifyCode 
          mobile_number={UserData.mobile_number}
          national_code={UserData.national_code}
        />
      )}
    </>
  )
}
